<div class="card sell-camp-summary">
    <div class="card-body">
        <div class="card-title main-blue font-weight-bold">
            {{ "SellCamp.Summary" | translate }}
        </div>
        @if (summary(); as summary) {
            <div>
                <div class="row">
                    <div class="col main-grey">
                        {{ "SellCampSummary.Person" | translate }}
                    </div>
                    <div
                        class="col d-flex justify-content-end font-weight-bold"
                    >
                        {{ summary.memberName }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col main-grey">
                        {{ "SellCampSummary.MemberId" | translate }}
                    </div>
                    <div
                        class="col d-flex justify-content-end font-weight-bold"
                    >
                        {{ summary.memberId }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col main-grey">
                        {{ "SellCampSummary.Child" | translate }}
                    </div>
                    <div
                        class="col d-flex justify-content-end font-weight-bold"
                    >
                        <span
                            ><span> {{ summary.childName }}</span>
                            <span class="ml-1"
                                >({{ summary.childAgeInMonth | age }})</span
                            ></span
                        >
                    </div>
                </div>
                <hr />
                <div class="row mt-2">
                    <div class="col main-grey">
                        {{ "SellCampSummary.Club" | translate }}
                    </div>
                    <div
                        class="col d-flex justify-content-end font-weight-bold"
                    >
                        {{ summary.clubName }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col main-grey">
                        {{ "SellCampSummary.Program" | translate }}
                    </div>
                    <div
                        class="col d-flex justify-content-end font-weight-bold"
                    >
                        {{ summary.campName }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col main-grey">
                        {{ "SellCampSummary.Session" | translate }}
                    </div>
                    <div
                        class="col d-flex justify-content-end font-weight-bold"
                    >
                        {{ summary.sessionName }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col main-grey">
                        {{ "SellCampSummary.Variant" | translate }}
                    </div>
                    <div
                        class="col d-flex justify-content-end font-weight-bold"
                    >
                        {{ summary.sessionVariantName }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col main-grey">
                        {{ "SellCampSummary.Dates" | translate }}
                    </div>
                    <div
                        class="col d-flex justify-content-end font-weight-bold"
                    >
                        {{ summary.startDate | bcDate: "MM/DD/YYYY" }} -
                        {{ summary.endDate | bcDate: "MM/DD/YYYY" }}
                    </div>
                </div>
                <hr />
                @if (summary?.options?.length) {
                    @for (option of summary.options; track option) {
                        <div class="row mt-3">
                            <div class="col main-grey" hznTestId="sell-camp-summary-option">
                                {{ option.name }}
                            </div>
                            <div
                                class="col d-flex justify-content-end font-weight-bold"
                            >
                                {{ option.netPrice | currency }}
                            </div>
                        </div>
                        <!-- <div class="row mt" *ngIf="option.tax">
            <div class="col main-grey">
              {{ "SellCampSummary.Tax" | translate:{ taxRate: option.taxRate} }}
            </div>
            <div class="col d-flex justify-content-end font-weight-bold">
              {{option.tax | currency}}
            </div>
          </div>
          <div class="row mt" *ngIf="option.tax">
            <div class="col main-grey">
              {{'SellCampSummary.Total' | translate}}
            </div>
            <div class="col d-flex justify-content-end font-weight-bold">
              {{option.price | currency}}
            </div>
          </div> -->
                    }
                    <hr />
                }
                <div class="row mt-3">
                    <div class="col main-grey">
                        {{ "SellCampSummary.Price" | translate }}
                    </div>
                    <div
                        class="col d-flex justify-content-end font-weight-bold"
                    >
                        {{ summary.sessionsNetPrice | currency }}
                    </div>
                </div>
                @if (summary?.coupon?.totalValue > 0) {
                    <div class="row mt-2">
                        <div class="col col-auto main-grey">
                            {{
                                "SellCampSummary.Coupon"
                                    | translate
                                        : {
                                              value: summary.coupon.coupon
                                                  .description,
                                          }
                            }}
                        </div>
                        <div
                            class="col d-flex justify-content-end font-weight-bold"
                        >
                            -{{ summary.coupon.totalValue | currency }}
                        </div>
                    </div>
                }
                @if (summary.tax) {
                    <div class="row mt-2">
                        <div class="col main-grey">
                            {{
                                "SellCampSummary.Tax"
                                    | translate: { taxRate: summary.taxRate }
                            }}
                        </div>
                        <div
                            class="col d-flex justify-content-end font-weight-bold"
                        >
                            {{ summary.tax | currency }}
                        </div>
                    </div>
                }
                <hr />
                <div class="row mt-3">
                    <div class="col main-grey">
                        {{ "SellCampSummary.Total" | translate }}
                    </div>
                    <div
                        class="col d-flex justify-content-end font-weight-bold"
                    >
                        {{ summary.price | currency }}
                    </div>
                </div>
            </div>
        }
    </div>
</div>
